'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFormInitialValues = exports.getUsername = exports.getRememberUsername = exports.getKeepMeLoggedIn = exports.getRecoverLoginUrl = exports.getRecoverLoginUrlNolang = exports.getMessagePlaceholders = exports.getMessageText = exports.getMessageTitle = exports.getMessage = exports.getComponentMethodToCall = exports.isFetching = exports.getCasData = undefined;

var _immutable = require('immutable');

var _reselect = require('reselect');

var _languageCommon = require('@wh/language-common');

var getCasData = exports.getCasData = function getCasData(state) {
    return state.getIn(['loginComponent', 'casData'], (0, _immutable.Map)());
};
var isFetching = exports.isFetching = function isFetching(state) {
    return state.getIn(['loginComponent', 'isFetching'], false);
};
var getComponentMethodToCall = exports.getComponentMethodToCall = function getComponentMethodToCall(state) {
    return state.getIn(['loginComponent', 'componentMethodToCall'], '');
};
var getMessage = exports.getMessage = function getMessage(state) {
    return state.getIn(['loginComponent', 'message'], (0, _immutable.Map)());
};
var getMessageTitle = exports.getMessageTitle = function getMessageTitle(state) {
    return state.getIn(['loginComponent', 'message', 'title'], '');
};
var getMessageText = exports.getMessageText = function getMessageText(state) {
    return state.getIn(['loginComponent', 'message', 'text'], '');
};
var getMessagePlaceholders = exports.getMessagePlaceholders = function getMessagePlaceholders(state) {
    return state.getIn(['loginComponent', 'message', 'placeholders'], (0, _immutable.Map)());
};

var getRecoverLoginUrlNolang = exports.getRecoverLoginUrlNolang = function getRecoverLoginUrlNolang(state) {
    return state.getIn(['loginComponent', 'recoverLoginUrl'], '');
};

var getRecoverLoginUrl = exports.getRecoverLoginUrl = (0, _reselect.createSelector)(_languageCommon.getActiveLanguageAndCountryCode, getRecoverLoginUrlNolang, function (langCode, url) {
    return url ? url.replace('nolang', langCode) : '';
});

// this value indicates if "keep me logged in" checkbox should be available
// but checkbox always should be unchecked by default
var getKeepMeLoggedIn = exports.getKeepMeLoggedIn = function getKeepMeLoggedIn(state) {
    return state.getIn(['loginComponent', 'formDefaults', 'keepMeLoggedIn'], false);
};
var getRememberUsername = exports.getRememberUsername = function getRememberUsername(state) {
    return state.getIn(['loginComponent', 'formDefaults', 'rememberUsername'], false);
};
var getUsername = exports.getUsername = function getUsername(state) {
    return state.getIn(['loginComponent', 'formDefaults', 'username'], '');
};
var getFormInitialValues = exports.getFormInitialValues = function getFormInitialValues(state) {
    return {
        username: getUsername(state),
        keepMeLoggedIn: false,
        rememberUsername: getRememberUsername(state)
    };
};
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/selectors.js
// module id = 132
// module chunks = 0